



























































































































































































































































































































































































































































































declare var window: any;
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { countries } from '../Commons/phone-code-countries';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';

@Component({
  name: 'ProfessionalReference',
  components: {
    ProfilePlaceholder,
    AddEntity,
    VueGoogleAutocomplete,
    Datepicker,
  },
})
export default class ProfessionalReference extends Vue {
  @Prop() bus;
  @Prop () isRequiredStep;
  @Prop () minimumEntries;
  $moment: any;
  $wlToastr: any;
  private showForm = false;
  private selectedItem;
  private refPhone = '';
  private referenceFirstName = '';
  private referenceLastName = '';
  private referencePhone = '';
  private referenceEmail = '';
  private title = '';
  private companyName = '';
  private country = '';
  private state = '';
  private city = '';
  private countryCode: string = '';
  private noExample: boolean = true;
  private phoneNumberValid = true;
  private location = '';
  private referenceType = '01';
  private fromDate: any = '';
  private toDate: any = '';
  private consent = false;
  private errors = {
    referenceFirstName: '',
    referenceLastName: '',
    referencePhone: '',
    companyName: '',
    referenceEmail: '',
    myJobTitle: '',
    referenceJobTitle: '',
    location: '',
    fromDate: '',
    toDate: '',
    consent: '',
    relationship: '',
    salutation: '',
    referenceType: '',
  };
  private myJobTitle = '';
  private referenceJobTitle = '';
  private salutationOptions = [
    'Mr.',
    'Ms.',
    'Dr.',
    'Professor',
    'Mrs.',
    'Mx.',
    'None Preferred',
  ];
  private relationShipOptions = [
    'Manager (Supervisor, Boss)',
    'Teacher (Professor, Instructor)',
    'Coworker (or fellow Employee)',
    'Peer (or Colleague)',
    'Subordinate (or Direct Report)',
    'Client (or Customer)',
    'Other',
  ];
  private relationShip = '';
  private salutation = this.salutationOptions[0];

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  @Watch('professionalReferenceList')
  onUpdateList(newVal) {
    const disable = this.minimumEntries >= 0 ? (this.isRequiredStep 
    ? newVal.length < this.minimumEntries : this.isRequiredStep) : newVal.length < this.getMinimumEntries;
    this.$emit('disable-next-button', disable);
  }

  get getMinimumEntries() {
    let minimumEntries = 1;
    if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.getMinimumEntriesConfig('PROFESSIONAL_REFERENCE') > 1 ? vxm.configs.getMinimumEntriesConfig('PROFESSIONAL_REFERENCE') : minimumEntries;
      }
    const step = this.CurrentStep;
    if (step && step.meta) {
      const stepMeta = JSON.parse(step.meta);
      minimumEntries = stepMeta.minimumEntries || minimumEntries;
    }
    return minimumEntries;
  }

  get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }

  mounted() {
    vxm.users.listProfessionalReference();
    vxm.users.fetchWizardSteps();
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    this.bus.$on('on-next-step', this.goToNext);
  }

  fullName(reference) {
    return `${
      reference.salutation === 'None Preferred' ? '' : reference.salutation
    } ${reference.referenceFirstName} ${reference.referenceLastName}`;
  }

  isProfessionalFieldVisible(key: string) {
    if (vxm.configs.IsConfigJSONEnabled) {
      return vxm.configs.visibilityFieldConfigValue('PROFESSIONAL_REFERENCE', key);
    }
    return true;
  }

  goToNext() {
    this.$emit('go-to-next');
  }

  get professionalReferenceList() {
    return vxm.users.ProfessionalReferenceList;
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'PROFESSIONAL_REFERENCE',
      );
      return section ? section.displayName : 'Professional References';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'PROFESSIONAL_REFERENCE',
    );
    return section ? section.displayName : 'Professional References';
  }

  setSelectedLocation(address, addressInfo) {
    const addressComponent =
      addressInfo.address_components.find(
        (component) =>
          component.short_name === address.administrative_area_level_1,
      ) || {};
    this.state =
      addressComponent.long_name || address.administrative_area_level_1;
    this.country = address.country;
    this.city = address.locality || '';
  }

  get isMyProfile() {
    var str = this.$route.path!;
    console.log('str is ', str);
    console.log('returning ', str.includes('myprofile/v2'));
    return str.includes('myprofile/v2');
  }

  async saveProfessionalReference() {
    const vm = this;
    const isInvalid = this.validateProfessionalReferenceForm();
    if (isInvalid) {
      return;
    }

    const payload = {
      salutation: this.salutation,
      referenceFirstName: this.referenceFirstName,
      referenceLastName: this.referenceLastName,
      referenceName: `${this.referenceFirstName} ${this.referenceLastName}`,
      referencePhone: this.referencePhone,
      referenceEmail: this.referenceEmail,
      country: this.country,
      state: this.state,
      city: this.city,
      referenceType: this.referenceType,
      workedTogetherFrom: vxm.utility.convertLocalTimeToUTC(this.fromDate),
      workedTogetherTo: vxm.utility.convertLocalTimeToUTC(this.toDate),
      relationship: this.relationShip,
      companyName: this.companyName,
      referenceJobTitleWhenWorkedTogether: this.referenceJobTitle,
      title: this.referenceJobTitle,
      candidateJobTitleWhenWorkedTogether: this.myJobTitle,
      consent: this.consent,
      candidateProfessionalReferenceId: this.selectedItem,
    };
    if (this.selectedItem) {
      const updateRespPromise: any = vxm.users.updateProfessionalReference(
        payload,
      );
      const updateResponse = await updateRespPromise;
      if (updateResponse.success) {
        vxm.users.Rudderstack.trackEvent("Professional References Updated", {ProfessionalRefrencesData : payload})
        vm.$wlToastr(
          'success',
          vm.$t('professionalReferences-details-updated').toString(),
          '',
        );
      } else {
        vm.$wlToastr('error', updateResponse.errorMessage, '');
      }
    } else {
      const saveRespPromise: any = vxm.users.saveProfessionalReference(payload);
      const saveResponse = await saveRespPromise;
      if (saveResponse.error) {
        vm.$wlToastr('error', saveResponse.errorMessage, '');
      } else {
        vm.$wlToastr(
          'success',
          vm.$t('professionalReferences-details-saved').toString(),
          '',
        );
      }
    }
    vxm.users.getProfileStrength();
    vxm.users.listProfessionalReference();
    this.showForm = false;
  }
  editProfessionalReference(id) {
    this.showForm = true;
    const selectedItem = this.professionalReferenceList.find(
      (reference) => reference.candidateProfessionalReferenceId === id,
    );
    if (!selectedItem) {
      return;
    }
    this.salutation = selectedItem.salutation;
    this.referenceFirstName = selectedItem.referenceFirstName;
    this.referenceLastName = selectedItem.referenceLastName;
    this.setCountryCodeAndNumber(selectedItem);
    this.referenceEmail = selectedItem.referenceEmail;
    this.city = selectedItem.city || '';
    this.state = selectedItem.state || '';
    this.country = selectedItem.country || '';
    const locationArray: any = [];
    this.city && locationArray.push(this.city);
    this.state && locationArray.push(this.state);
    this.country && locationArray.push(this.country);
    this.location = `${locationArray.join(', ')}`;
    this.referenceType = selectedItem.referenceType;
    this.fromDate =
      (selectedItem.workedTogetherFrom &&
        new Date(selectedItem.workedTogetherFrom)) ||
      '';
    this.toDate =
      (selectedItem.workedTogetherTo &&
        new Date(selectedItem.workedTogetherTo)) ||
      '';
    this.companyName = selectedItem.companyName;
    this.relationShip = selectedItem.relationship || '';
    this.myJobTitle = selectedItem.candidateJobTitleWhenWorkedTogether;
    this.referenceJobTitle = selectedItem.referenceJobTitleWhenWorkedTogether;
    this.selectedItem = selectedItem.candidateProfessionalReferenceId;
    this.consent = selectedItem.consent;
    this.errors = {
      referenceFirstName: '',
      referenceLastName: '',
      referencePhone: '',
      companyName: '',
      referenceEmail: '',
      myJobTitle: '',
      referenceJobTitle: '',
      location: '',
      fromDate: '',
      toDate: '',
      consent: '',
      relationship: '',
      salutation: '',
      referenceType: '',
    };
  }

  setCountryCodeAndNumber(selectedItem) {
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    this.refPhone = selectedItem.referencePhone.substring(
      selectedItem.referencePhone.indexOf(' ') + 1,
    );
    let dialCode = selectedItem.referencePhone.substring(
      1,
      selectedItem.referencePhone.indexOf(' '),
    );
    for (var i = 0; i < countries.length; i++) {
      if (countries[i].dialCode === dialCode) {
        this.countryCode = countries[i].iso2;
      }
    }
  }

  async deleteProfessionalReference(id) {
    const selectedItem = this.professionalReferenceList.find(
      (reference) => reference.candidateProfessionalReferenceId === id,
    );
    if (!selectedItem) {
      return;
    }
    const selectedObj = {
      candidateProfessionalReferenceId: id,
    };
    const deleteRespPromise: any = vxm.users.deleteProfessionalReference(
      selectedObj,
    );
    const deleteResp = await deleteRespPromise;
    if (deleteResp.success) {
      vxm.users.Rudderstack.trackEvent("Professional References Deleted", {} )
      this.$wlToastr(
        'success',
        this.$t('professionalReferences-details-deleted').toString(),
        '',
      );
    } else {
      this.$wlToastr('error', deleteResp.errorMessage, '');
    }
    vxm.users.getProfileStrength();
    vxm.users.listProfessionalReference();
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'PROFESSIONAL_REFERENCE');
  }

  createNewProfessionalReference() {
    this.showForm = true;
    this.referenceFirstName = '';
    this.referenceLastName = '';
    this.referencePhone = '';
    this.referenceEmail = '';
    this.title = '';
    this.companyName = '';
    this.selectedItem = null;
    this.countryCode = vxm.jobs.getCompanyCountryCode;
    this.refPhone = '';
    this.salutation = '';
    this.location = '';
    this.city = '';
    this.country = '';
    this.state = '';
    this.referenceType = '01';
    this.fromDate = '';
    this.toDate = '';
    this.relationShip = '';
    this.myJobTitle = '';
    this.referenceJobTitle = '';
    this.errors = {
      referenceFirstName: '',
      referenceLastName: '',
      referencePhone: '',
      companyName: '',
      referenceEmail: '',
      myJobTitle: '',
      referenceJobTitle: '',
      location: '',
      fromDate: '',
      toDate: '',
      consent: '',
      relationship: '',
      salutation: '',
      referenceType: '',
    };
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }

  get isProfessionalReferenceSubHeaderEnabled() {
    return vxm.configs.getGlobalConfigValue('ENABLE_PROFESSIONAL_REFERENCE_SUB_HEADER')
  }

  get sectionSubHeader() {
    const section = this.CurrentStep;
      if( this.isConfigEnabled && this.getMinimumEntries>1 && this.userPermissionConfig('edit')){
      return this.$t('professionalReferences-required-step-info', {
          entries: this.getMinimumEntries,
        }).toString();
    }
    else if((!this.isConfigEnabled || (this.isConfigEnabled &&this.userPermissionConfig('edit'))) && section && section.sectionSubHeader){
     return section.sectionSubHeader
    }
    else if((!this.isConfigEnabled || (this.isConfigEnabled &&this.userPermissionConfig('edit')))){
     return this.$t('professionalReferences-required-step-info', {
          entries: this.getMinimumEntries,
        }).toString();

    }

  }

  get CurrentStep() {
    return vxm.users.ProfileWizardSteps.find((step) => {
      return step.stepName === 'PROFESSIONAL_REFERENCE';
    });
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    let phone = '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.referencePhone = phone;

    this.phoneNumberValid = event.isValid;
  }

  // formatPhone = (phoneNumber) => {
  //   phoneNumber = phoneNumber.substring(1, 14);
  //   return phoneNumber
  //     .replace(/\D+/g, '')
  //     .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  // };
  validateProfessionalReferenceForm() {
    this.errors = {
      referenceFirstName: this.referenceFirstName && this.referenceFirstName.trim()
          ? ''
          : this.$t('professionalReferences-first.name.required').toString(),
      referenceLastName: this.referenceLastName && this.referenceLastName.trim()
          ? ''
          : this.$t('professionalReferences-last.name.required').toString(),
      referenceEmail: this.referenceEmail ? '' : this.$t('professionalReferences-email.required').toString(),
      companyName: this.companyName && this.companyName.trim() ? '' : this.$t('professionalReferences-company.required').toString(),
      referencePhone: this.referencePhone ? '' : this.$t('professionalReferences-phone.number.required').toString(),
      myJobTitle: this.myJobTitle && this.myJobTitle.trim() ? '' : this.$t('professionalReferences-myjob.required').toString(),
      referenceJobTitle: this.referenceJobTitle && this.referenceJobTitle.trim()
          ? ''
          : this.$t('professionalReferences-reference.jobtitle.required').toString(),
      location: this.city ? '' : this.$t('Location is required').toString(),
      fromDate: this.fromDate ? '' : this.$t('professionalReferences-from.date.required').toString(),
      toDate: this.toDate ? '' : this.$t('professionalReferences-to.date.required').toString(),
      consent: this.consent ? '' : this.$t('professionalReferences-concent.required').toString(),
      relationship: this.relationShip ? '' : this.$t('professionalReferences-relationship.required').toString(),
      salutation: this.salutation ? '' : this.$t('professionalReferences-Salutation.required').toString(),
      referenceType: this.referenceType ? '' : this.$t('professionalReferences-reference.required').toString(),
    };
    if (
      this.fromDate &&
      this.toDate &&
      this.fromDate.getTime() >= this.toDate.getTime()
    ) {
      this.errors.fromDate = this.$t('professionalReferences-startmonth.less.than.endmonth').toString();
    }
    if (!this.phoneNumberValid) {
      this.errors.referencePhone = this.$t('professionalReferences-valid.phone.number').toString();
    }
    const emailformat = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (this.referenceEmail && !this.referenceEmail.match(emailformat)) {
      this.errors.referenceEmail = this.$t('professionalReferences-valid.email').toString();
    }
    const isInvalid = Object.keys(this.errors).some((entity) => {
      return this.errors[entity];
    });
    return isInvalid;
  }
  confirmDeleteProfessionalReference(id: number) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('professionalReferences-delete').toString(),
        body: '',
        okText: this.$t('global.ok.text').toString(),
        cancelText: this.$t('global.cancel-text').toString(),
        onOk: () => {
          this.deleteProfessionalReference(id);
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
}
